module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Simone_CR-f06b26127b66c5e9f08ccc72c6fcdd80.jpg";